//services/index.ts
import userController from "./users";
import checkoutController from "./checkouts";
import contactController from "./contact";
import businessController from "./business";
import technicalAnalysisController from "./technical-analysis";
import adminController from "./admin";
import * as reportsController from "./reports";
import { socialMediaAPI } from "./api";

export const API = {
  admin: adminController,
  users: userController,
  checkouts: checkoutController,
  contact: contactController,
  business: businessController,
  technicalAnalysis: technicalAnalysisController,
  reports: reportsController,
};

export type {
  ReportTier,
  ReportListItem,
  ReportDetail,
  ManualGenerateResponse,
  PaginatedResponse,
  ReportLanguage,
  ReportLogoMode,
  ReportBrandingConfig,
} from "./reports";

export { socialMediaAPI };
